import {
  AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild, ViewEncapsulation,
} from '@angular/core';
/**
 * Enumerations von Syncfusion bsp. Toolbar-Items
 * node_modules/@syncfusion/ej2-pdfviewer/src/pdfviewer/base/types.d.ts
 */
import {
  AllowedInteraction,
  AnnotationAddEventArgs,
  AnnotationMoveEventArgs,
  AnnotationPropertiesChangeEventArgs,
  AnnotationRemoveEventArgs,
  AnnotationResizeEventArgs,
  AnnotationSelectEventArgs,
  AnnotationService,
  AnnotationUnSelectEventArgs,
  BookmarkViewService,
  CommentEventArgs,
  DownloadStartEventArgs,
  FormDesignerService,
  FormFieldsService,
  ImportSuccessEventArgs,
  LinkAnnotationService,
  LoadEventArgs,
  MagnificationService,
  NavigationService,
  PdfViewerComponent,
  PrintService,
  TextSearchService,
  TextSelectionEndEventArgs,
  TextSelectionService,
  ThumbnailViewService,
  ToolbarService,
} from '@syncfusion/ej2-angular-pdfviewer';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';

import {L10n, loadCldr} from '@syncfusion/ej2-base';
import {ExgModalService} from 'exc-controls-v2';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-exc-pdfviewer',
  templateUrl: './exc-pdfviewer.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    LinkAnnotationService,
    BookmarkViewService,
    MagnificationService,
    ThumbnailViewService,
    ToolbarService,
    NavigationService,
    TextSearchService,
    TextSelectionService,
    PrintService,
    AnnotationService,
    FormFieldsService,
    FormDesignerService,
  ],
})
export class ExcPdfviewerComponent
  extends ExcTranslation
  implements OnInit, AfterViewInit
{
  /**
   * View-Childs
   */
  @ViewChild(PdfViewerComponent) VCSyncfusionPdfViewer!: PdfViewerComponent;
  @ViewChild(PdfViewerComponent, { read: ElementRef })
  DivPdfViewer!: ElementRef;
  /**
   * Output
   */
  @Output() annotationAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() annotationDeleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() annotationSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() annotationUnselected: EventEmitter<any> = new EventEmitter<any>();
  @Output() annotationChanged: EventEmitter<any> = new EventEmitter<any>();

  @Output() commentAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() commentDeleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() commentUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Output() commentSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() commentChanged: EventEmitter<any> = new EventEmitter<any>();

  @Output() viewerTextSelection: EventEmitter<any> = new EventEmitter<any>();
  @Output() viewerDocumentLoaded: EventEmitter<any> = new EventEmitter<any>();
  @Output() ready: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Input
   */
  @Input()
  set docPath(value: string) {
    this._docPath = value;
    this.init = true;
  }
  get docPath(): string {
    return this._docPath;
  }
  private _docPath!: string;
  @Input()
  set docName(value: string) {
    this._docName = value;
  }
  get docName(): string {
    return this._docName;
  }
  private _docName = 'fileName';
  @Input()
  set docID(value: string) {
    this._docID = value;
  }
  get docID(): string {
    return this._docID;
  }
  _docID = '';
  @Input()
  set docAnnotations(value: any) {
    if (typeof value === 'string') {
      this._docAnnotations = JSON.parse(value);
    } else {
      this._docAnnotations = value;
    }
  }
  get docAnnotations(): any {
    return this.VCSyncfusionPdfViewer
      ? this.VCSyncfusionPdfViewer.annotationCollection
      : this._docAnnotations;
  }
  _docAnnotations: any[] = [];

  init = false;
  service = environment.rest.PdfViewerUrl;
  textSelection = '';
  /**
   * node_modules/@syncfusion/ej2-pdfviewer/src/pdfviewer/pdfviewer.d.ts
   * toolbarItemsConfig
   *
   */
  viewerConfig = {
    defaultValues: {
      annotationInteractions: [
        AllowedInteraction.Delete,
        AllowedInteraction.Move,
        AllowedInteraction.PropertyChange,
        AllowedInteraction.Resize,
        AllowedInteraction.Select,
      ],
      toolbarItems: [
        'PageNavigationTool',
        'MagnificationTool',
        'PanTool',
        'SelectionTool',
        'SearchOption',
        'UndoRedoTool',
        'AnnotationEditTool',
        'CommentTool',
        'PrintOption',
        'DownloadOption',
      ],
    },
    toolbarItemsConfig: {
      showTooltip: true,
      toolbarItems: [
        'PageNavigationTool',
        'MagnificationTool',
        'PanTool',
        'SelectionTool',
        'SearchOption',
        'AnnotationEditTool',
        'PrintOption',
        'DownloadOption',
      ],
      // AnnotationToolbarItem[]
      annotationToolbarItems: [
        'HighlightTool',
        'UnderlineTool',
        'StrikethroughTool',
        'ShapeTool',
        'CalibrateTool',
        'ColorEditTool',
        'StrokeColorEditTool',
        'ThicknessEditTool',
        'OpacityEditTool',
        'AnnotationDeleteTool',
        'StampAnnotationTool',
        'InkAnnotationTool',
        'FreeTextAnnotationTool',
        'FontFamilyAnnotationTool',
        'FontSizeAnnotationTool',
        'FontStylesAnnotationTool',
        'FontAlignAnnotationTool',
        'FontColorAnnotationTool',
      ],
      // FormDesignerToolbarItem[]
      formDesignerToolbarItems: [],
    },

    toolbar: {
      enableTextSelection: true,
      enableCommentPanel: true,
      enableAnnotation: true,
      enableAnnotationToolbar: true,
    },
    visibility: {
      isAnnotationToolbarOpen: true,
      isCommandPanelOpen: false,
    },

    AnnotationSettings: {
      allowedInteractions: [AllowedInteraction.Select],
      author: this.excSec.UserName,
      isLock: true,
      // specifies the custom data of the annotation.
      customData: {},

      skipPrint: false,
      skipDownload: false,
    },
    freeTextAnnotationSettings: {
      author: this.excSec.UserName,
      // isLock: true,
      // enableAutoFit: true,
      // isReadonly: false,
      // isPrint: true,
      defaultText: 'im Editor editieren',
    },
  };

  constructor(
    public enumSvc: EnumerationService,
    public excSec: ExcSecurityService,
    private modalService: ExgModalService,
    private renderer: Renderer2
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadViewerTranslation();
    this.registerEvents();
  }

  ngAfterViewInit(): void {
    if (this.VCSyncfusionPdfViewer) {
      this.VCSyncfusionPdfViewer.downloadFileName = this.docName;
      this.VCSyncfusionPdfViewer.annotation.updateSettings(
        this.viewerConfig.AnnotationSettings
      );
    }
  }

  registerEvents(): void {
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      this.reload();
    });
  }

  documentLoaded(event: LoadEventArgs): void {
    if (event.pageData) {
      this.viewerDocumentLoaded.emit(event);
    }
  }

  reload(): void {
    if (this.docPath) {
      this.VCSyncfusionPdfViewer.unload();
      this.VCSyncfusionPdfViewer.load(this.docPath, '');
    }
  }

  getFile(): Promise<FormData> {
    return this.VCSyncfusionPdfViewer.saveAsBlob().then((blob: Blob) => {
      const formData = new FormData();
      formData.append(
        'file[]',
        blob,
        `${Date.now().toString()}_${this.docName}`
      );
      return formData;
    });
  }

  viewerReady(event: ImportSuccessEventArgs): void {
    if (event) {
      this.ready.emit(event);
    }
  }

  hyperlinkClicked(event: any): void {
    event.cancel = true;
    this.modalService
      .showSimple(
        'Link Öffnen?',
        `Hyperlink: ${event.hyperlink}`,
        true,
        true,
        'Öffnen',
        'Abbrechen'
      )
      .subscribe((open) => {
        if (open) {
          window.open(event.hyperlink, '_blank');
        }
      });
  }

  textSelected(event: TextSelectionEndEventArgs): void {
    this.textSelection = event.textContent;
    this.viewerTextSelection.emit(event.textContent);
  }

  downloadStart(event: DownloadStartEventArgs): void {
    this.VCSyncfusionPdfViewer.downloadFileName = this.docName;
  }

  disableAnnotationTools(): void {
    this.viewerConfig.toolbar.enableAnnotationToolbar = false;
    this.viewerConfig.AnnotationSettings.allowedInteractions = [
      AllowedInteraction.Select,
    ];
    this.VCSyncfusionPdfViewer.annotationModule.updateSettings(
      this.viewerConfig.AnnotationSettings
    );
    this.setAnnotationToolbarItems(false);
  }

  enableAnnotationTools(forbidden: boolean): void {
    if (forbidden) {
      this.viewerConfig.AnnotationSettings.allowedInteractions =
        this.viewerConfig.defaultValues.annotationInteractions;
      this.setDefaultsFreeTextAnnotationSettings();
      this.VCSyncfusionPdfViewer.annotation.updateSettings(
        this.viewerConfig.AnnotationSettings
      );
      this.setAnnotationToolbarItems(true);
    } else {
      this.disableAnnotationTools();
    }
  }

  setAnnotationToolbarItems(value: boolean): void {
    this.VCSyncfusionPdfViewer.toolbar.showToolbarItem(['CommentTool'], value);
    this.VCSyncfusionPdfViewer.toolbar.enableToolbarItem(
      ['CommentTool'],
      value
    );
    this.VCSyncfusionPdfViewer.toolbar.annotationToolbarModule.showToolbar(
      value
    );
  }

  setDefaultsFreeTextAnnotationSettings(): void {
    this.VCSyncfusionPdfViewer.freeTextSettings.author =
      this.viewerConfig.freeTextAnnotationSettings.author;
    this.VCSyncfusionPdfViewer.freeTextSettings.defaultText =
      this.viewerConfig.freeTextAnnotationSettings.defaultText;
  }

  annotationEventListener = (
    event:
      | AnnotationAddEventArgs
      | AnnotationMoveEventArgs
      | AnnotationRemoveEventArgs
      | AnnotationPropertiesChangeEventArgs
      | AnnotationResizeEventArgs
      | AnnotationSelectEventArgs
      | AnnotationUnSelectEventArgs
  ): void => {
    // Toolbar going out of context

    switch (event.name) {
      case 'annotationAdd': {
        this.annotationAdded.emit(event);
        this.annotationChanged.emit(event);
        break;
      }
      case 'annotationRemove': {
        this.annotationDeleted.emit(event);
        this.annotationChanged.emit(event);
        break;
      }
      case 'annotationSelect': {
        this.annotationSelected.emit(event);
        break;
      }
      case 'annotationUnSelect': {
        this.annotationUnselected.emit(event);
        break;
      }
      default: {
        this.annotationChanged.emit(event);
        break;
      }
    }
  }

  commentEventListener = (event: CommentEventArgs): void => {
    // console.log(event);
    const annotation = event.annotation;

    switch (event.name) {
      case 'commentAdd': {
        this.commentAdded.emit(event);
        this.commentChanged.emit(event);
        break;
      }
      case 'commentDelete': {
        this.commentDeleted.emit(event);
        this.commentChanged.emit(event);
        this.annotationChanged.emit(annotation);
        break;
      }
      case 'commentSelect': {
        this.commentSelected.emit(event);
        break;
      }
      default: {
        this.commentUpdated.emit(event);
        this.commentChanged.emit(event);
        this.annotationChanged.emit(annotation);
        break;
      }
    }
  }

  /**
   * Übersetzung L10n
   *
   * Übersetzt per Word + Teilanpassungen
   * Objekt im debugger entnommen, deckt also alle vorkommenden Wörter ab
   */
  loadViewerTranslation(): void {
    const cLang: string = this.currentLang() || 'de';

    if (cLang === 'de') {
      L10n.load({
        de: {
          PdfViewer: {
            PdfViewer: 'PDF-Viewer',
            Cancel: 'Abbrechen',
            'Download file': 'Download Datei',
            Download: 'Herunterladen',
            'Enter Password':
              'Dieses Dokument ist Passwort geschützt. Bitte geben Sie das Passwort ein.',
            'File Corrupted': 'Datei beschädigt',
            'File Corrupted Content':
              'Die Datei ist beschädigt und kann nicht geöffnet werden.',
            'Fit Page': 'Ganze Seite',
            'Fit Width': 'Voll Breite',
            Automatic: 'Automatisch',
            'Go To First Page': 'Erste Seite anzeigen',
            'Invalid Password':
              'Falsches Passwort. Bitte versuchen Sie es erneut.',
            'Next Page': 'Nächste Seite anzeigen',
            OK: 'Okay',
            Open: 'Öffnen',
            'Page Number': 'Aktuelle Seitenzahl',
            'Previous Page': 'Vorherige Seite anzeigen',
            'Go To Last Page': 'Letzte Seite anzeigen',
            Zoom: 'Zoom',
            'Zoom In': 'Vergrößern',
            'Zoom Out': 'Verkleinern',
            'Page Thumbnails': 'Seitenminiaturansichten',
            Bookmarks: 'Lesezeichen',
            Print: 'Druckdatei',
            'Password Protected': 'Passwort erforderlich',
            Copy: 'Kopieren',
            'Text Selection': 'Textauswahl-Werkzeug',
            Panning: 'Schwenkmodus',
            'Text Search': 'Text suchen',
            'Find in document': 'Im Dokument suchen',
            'Match case': 'Groß-/Kleinschreibung abgleichen',
            Apply: 'Anwenden',
            GoToPage: 'Gehe zu Seite',
            'No matches':
              'Der Viewer hat die Suche im Dokument abgeschlossen. Es wurden keine Übereinstimmungen mehr gefunden.',
            'No Text Found': 'Kein Text gefunden',
            Undo: 'Rückgängig',
            Redo: 'Wiederholen',
            Annotation: 'Hinzufügen oder Bearbeiten von Anmerkungen',
            FormDesigner: 'Hinzufügen und Bearbeiten von Formularfeldern',
            Highlight: 'Text hervorheben',
            Underline: 'Text unterstreichen',
            Strikethrough: 'Durchgestrichener Text',
            Delete: 'Anmerkungen löschen',
            Opacity: 'Undurchsichtigkeit',
            'Color edit': 'Farbe ändern',
            'Opacity edit': 'Deckkraft ändern',
            'Highlight context': 'Höhepunkt',
            'Underline context': 'Unterstreichen',
            'Strikethrough context': 'Durchgestrichen',
            'Server error':
              'Der Webdienst hört nicht zu. PDF Viewer ist für alle seine Funktionen auf den Web-Service angewiesen. Starten Sie den Webdienst, um fortzufahren.',
            'Client error':
              'Clientseitiger Fehler wurde gefunden. Überprüfen Sie die benutzerdefinierten Header, die in der AjaxRequestSettings-Eigenschaft bereitgestellt werden, und die Webaktionsmethoden in der ServerActionSettings-Eigenschaft.',
            'Open text': 'Offen',
            'First text': 'Erste Seite',
            'Previous text': 'Vorherige Seite',
            'Next text': 'Nächste Seite',
            'Last text': 'Letzte Seite',
            'Zoom in text': 'Vergrößern',
            'Zoom out text': 'Verkleinern',
            'Selection text': 'Auswahl',
            'Pan text': 'Herr',
            'Print text': 'Datei Drucken',
            'Search text': 'Datei durchsuchen',
            'Annotation Edit text': 'Anmerkung bearbeiten',
            'FormDesigner Edit text':
              'Hinzufügen und Bearbeiten von Formularfeldern',
            'Line Thickness': 'Linienstärke',
            'Line Properties': 'Linieneigenschaften',
            'Start Arrow': 'Pfeil Start',
            'End Arrow': 'Pfeil zum Ende',
            'Line Style': 'Linienstil',
            'Fill Color': 'Füllfarbe',
            'Line Color': 'Linienfarbe',
            None: 'Nichts',
            'Open Arrow': 'Offen',
            'Closed Arrow': 'Geschlossen',
            'Round Arrow': 'Rund',
            'Square Arrow': 'Quadrat',
            'Diamond Arrow': 'Diamant',
            Butt: 'Hintern',
            Cut: 'Schneiden',
            Paste: 'Einfügen',
            'Delete Context': 'Löschen',
            Properties: 'Eigenschaften',
            'Add Stamp': 'Stempel hinzufügen',
            'Add Shapes': 'Hinzufügen von Shapes',
            'Stroke edit': 'Ändern der Konturfarbe',
            'Change thickness': 'Ändern der Rahmenstärke',
            'Add line': 'Zeile hinzufügen',
            'Add arrow': 'Pfeil hinzufügen',
            'Add rectangle': 'Rechteck hinzufügen',
            'Add circle': 'Kreis hinzufügen',
            'Add polygon': 'Polygon hinzufügen',
            'Add Comments': 'Kommentare hinzufügen',
            Comments: 'Kommentare',
            SubmitForm: 'Formular absenden',
            'No Comments Yet': 'Noch keine Kommentare',
            Accepted: 'Angenommen',
            Completed: 'Abgeschlossen',
            Cancelled: 'Abgebrochen',
            Rejected: 'Zurückgewiesen',
            'Leader Length': 'Länge des Leiters',
            'Scale Ratio': 'Skalierungsverhältnis',
            Calibrate: 'Kalibrieren',
            'Calibrate Distance': 'Abstand kalibrieren',
            'Calibrate Perimeter': 'Perimeter kalibrieren',
            'Calibrate Area': 'Bereich kalibrieren',
            'Calibrate Radius': 'Radius kalibrieren',
            'Calibrate Volume': 'Volumen kalibrieren',
            Depth: 'Tiefe',
            Closed: 'Geschlossen',
            Round: 'Rund',
            Square: 'Quadrat',
            Diamond: 'Diamant',
            Edit: 'Redigieren',
            Comment: 'Kommentar',
            'Comment Panel': 'Kommentarbereich',
            'Set Status': 'Status setzen',
            Post: 'Bereitstellen',
            Page: 'Seite',
            'Add a comment': 'Kommentieren',
            'Add a reply': 'Antworten',
            'Import Annotations': 'Importieren von Anmerkungen aus JSON-Datei',
            'Export Annotations': 'Anmerkung in JSON-Datei exportieren',
            'Export XFDF': 'Anmerkung in XFDF-Datei exportieren',
            'Import XFDF': 'Importieren von Anmerkungen aus der XFDF-Datei',
            Add: 'Hinzufügen',
            Clear: 'Löschen',
            Bold: 'Fett',
            Italic: 'Kursiv',
            Strikethroughs: 'Durchgestrichen',
            Underlines: 'Unterstreichen',
            Superscript: 'Exponent',
            Subscript: 'Subskript',
            'Align left': 'Links ausrichten',
            'Align right': 'Rechts ausrichten',
            Center: 'Mitte',
            Justify: 'Am Text ausrichten',
            'Font color': 'Schriftfarbe',
            'Text Align': 'Textausrichtung',
            'Text Properties': 'Schriftschnitt',
            SignatureFieldDialogHeaderText: 'Signatur hinzufügen',
            HandwrittenSignatureDialogHeaderText: 'Signatur hinzufügen',
            InitialFieldDialogHeaderText: 'Initial hinzufügen',
            HandwrittenInitialDialogHeaderText: 'Initial hinzufügen',
            'Draw Ink': 'Zeichnen',
            Create: 'Erstellen',
            'Font family': 'Schriftart',
            'Font size': 'Schriftgröße',
            'Free Text': 'Freitext',
            'Import Failed':
              'Ungültiger JSON-Dateityp oder ungültiger Dateiname; Wählen Sie eine gültige JSON-Datei aus.',
            'File not found':
              'Importierte JSON-Datei wird am gewünschten Speicherort nicht gefunden.',
            'Export Failed':
              'Die Aktion "Anmerkungen exportieren" ist fehlgeschlagen. Bitte stellen Sie sicher, dass Anmerkungen ordnungsgemäß hinzugefügt wurden.',
            of: 'von',
            Dynamic: 'Dynamisch',
            'Standard Business': 'Standardgeschäft',
            'Sign Here': 'Hier unterschreiben',
            'Custom Stamp': 'Benutzerdefinierter Stempel',
            'Enter Signature as Name': 'Geben Sie Ihren Namen ein',
            'Draw-hand Signature': 'Unterschrift',
            'Type Signature': 'Art',
            'Upload Signature': 'Hochladen',
            'Browse Signature Image': 'BLÄTTERN',
            'Save Signature': 'Signatur speichern',
            'Save Initial': 'Initial speichern',
            Textbox: 'Text',
            Password: 'Passwort',
            'Check Box': 'Kontrollkästchen',
            'Radio Button': 'Optionsfeld',
            Dropdown: 'Dropdown',
            'List Box': 'Listenfeld',
            Signature: 'Unterschrift',
            'Delete FormField': 'Formularfeld löschen',
            'Textbox Properties': 'Textbox-Eigenschaften',
            Name: 'Name',
            Tooltip: 'Quickinfo',
            Value: 'Wert',
            'Form Field Visibility': 'Sichtbarkeit von Formularfeldern',
            'Read Only': 'Schreibgeschützt',
            Required: 'Erforderlich',
            Checked: 'Geprüft',
            'Show Printing': 'Drucken anzeigen',
            Formatting: 'Format',
            Fill: 'Füllen',
            Border: 'Grenze',
            'Border Color': 'Rahmenfarbe',
            Thickness: 'Dicke',
            'Max Length': 'Max. Länge',
            'List Item': 'Artikelname',
            'Export Value': 'Artikelwert',
            'Dropdown Item List': 'Dropdownelementliste',
            'List Box Item List': 'Liste der Listenfeldelemente',
            General: 'Allgemein',
            Appearance: 'AUSSEHEN',
            Options: 'Optionen',
            'Delete Item': 'Löschen',
            Up: 'Hoch',
            Down: 'Runter',
            Multiline: 'Mehrzeilig',
            Revised: 'Überarbeitet',
            Reviewed: 'Geprüft',
            Received: 'Eingegangen',
            Confidential: 'Vertraulich',
            Approved: 'Gebilligt',
            'Not Approved': 'Nicht genehmigt',
            Witness: 'Zeuge',
            'Initial Here': 'Initial hier',
            Draft: 'Entwurf',
            Final: 'Final-Version',
            'For Public Release': 'Zur öffentlichen Veröffentlichung',
            'Not For Public Release':
              'Nicht zur öffentlichen Veröffentlichung bestimmt',
            'For Comment': 'Kommentare',
            Void: 'Leere',
            'Preliminary Results': 'Vorläufige Ergebnisse',
            'Information Only': 'Nur Informationen',
            in: 'in',
            m: 'm',
            ft_in: 'ft_in',
            ft: 'Ft',
            p: 'p',
            cm: 'cm',
            mm: 'Mm',
            pt: 'Pt',
            cu: 'mit',
            sq: 'Sq',
            Initial: 'Initial',
          },
        },
      });
    }
    loadCldr();
  }
}
